/*
 * Copyright 2024 Mifos Initiative
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/openMF/mobile-mobile/blob/master/LICENSE.md
 */
package org.mifos.mobile.core.designsystem.theme

import androidx.compose.ui.graphics.Color

val primaryLight = Color(0xFF33618D)
val onPrimaryLight = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFFD0E4FF)
val onPrimaryContainerLight = Color(0xFF154974)
val secondaryLight = Color(0xFF526070)
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFFD6E4F7)
val onSecondaryContainerLight = Color(0xFF3B4857)
val tertiaryLight = Color(0xFF6A5779)
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFFF1DBFF)
val onTertiaryContainerLight = Color(0xFF514060)
val errorLight = Color(0xFFBA1A1A)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFFDAD6)
val onErrorContainerLight = Color(0xFF93000A)
val backgroundLight = Color(0xFFF8F9FF)
val onBackgroundLight = Color(0xFF191C20)

// val surfaceLight = Color(0xFFF8F9FF)
val surfaceLight = Color(0xFFFFFFFF)
val onSurfaceLight = Color(0xFF191C20)
val surfaceVariantLight = Color(0xFFDFE3EB)
val onSurfaceVariantLight = Color(0xFF42474E)
val outlineLight = Color(0xFF73777F)
val outlineVariantLight = Color(0xFFC2C7CF)
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF2D3135)
val inverseOnSurfaceLight = Color(0xFFEFF0F7)
val inversePrimaryLight = Color(0xFF9ECAFC)
val surfaceDimLight = Color(0xFFD8DAE0)
val surfaceBrightLight = Color(0xFFF8F9FF)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFF2F3F9)
val surfaceContainerLight = Color(0xFFECEEF4)
val surfaceContainerHighLight = Color(0xFFE6E8EE)
val surfaceContainerHighestLight = Color(0xFFE0E2E8)

val primaryLightMediumContrast = Color(0xFF00385F)
val onPrimaryLightMediumContrast = Color(0xFFFFFFFF)
val primaryContainerLightMediumContrast = Color(0xFF43709D)
val onPrimaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val secondaryLightMediumContrast = Color(0xFF2A3746)
val onSecondaryLightMediumContrast = Color(0xFFFFFFFF)
val secondaryContainerLightMediumContrast = Color(0xFF616E7F)
val onSecondaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryLightMediumContrast = Color(0xFF402F4E)
val onTertiaryLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightMediumContrast = Color(0xFF796688)
val onTertiaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val errorLightMediumContrast = Color(0xFF740006)
val onErrorLightMediumContrast = Color(0xFFFFFFFF)
val errorContainerLightMediumContrast = Color(0xFFCF2C27)
val onErrorContainerLightMediumContrast = Color(0xFFFFFFFF)
val backgroundLightMediumContrast = Color(0xFFF8F9FF)
val onBackgroundLightMediumContrast = Color(0xFF191C20)
val surfaceLightMediumContrast = Color(0xFFF8F9FF)
val onSurfaceLightMediumContrast = Color(0xFF0E1116)
val surfaceVariantLightMediumContrast = Color(0xFFDFE3EB)
val onSurfaceVariantLightMediumContrast = Color(0xFF32373D)
val outlineLightMediumContrast = Color(0xFF4E535A)
val outlineVariantLightMediumContrast = Color(0xFF696D75)
val scrimLightMediumContrast = Color(0xFF000000)
val inverseSurfaceLightMediumContrast = Color(0xFF2D3135)
val inverseOnSurfaceLightMediumContrast = Color(0xFFEFF0F7)
val inversePrimaryLightMediumContrast = Color(0xFF9ECAFC)
val surfaceDimLightMediumContrast = Color(0xFFC4C6CC)
val surfaceBrightLightMediumContrast = Color(0xFFF8F9FF)
val surfaceContainerLowestLightMediumContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightMediumContrast = Color(0xFFF2F3F9)
val surfaceContainerLightMediumContrast = Color(0xFFE6E8EE)
val surfaceContainerHighLightMediumContrast = Color(0xFFDBDDE3)
val surfaceContainerHighestLightMediumContrast = Color(0xFFCFD1D7)

val primaryLightHighContrast = Color(0xFF002E4F)
val onPrimaryLightHighContrast = Color(0xFFFFFFFF)
val primaryContainerLightHighContrast = Color(0xFF194C77)
val onPrimaryContainerLightHighContrast = Color(0xFFFFFFFF)
val secondaryLightHighContrast = Color(0xFF202D3C)
val onSecondaryLightHighContrast = Color(0xFFFFFFFF)
val secondaryContainerLightHighContrast = Color(0xFF3D4A5A)
val onSecondaryContainerLightHighContrast = Color(0xFFFFFFFF)
val tertiaryLightHighContrast = Color(0xFF352544)
val onTertiaryLightHighContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightHighContrast = Color(0xFF544262)
val onTertiaryContainerLightHighContrast = Color(0xFFFFFFFF)
val errorLightHighContrast = Color(0xFF600004)
val onErrorLightHighContrast = Color(0xFFFFFFFF)
val errorContainerLightHighContrast = Color(0xFF98000A)
val onErrorContainerLightHighContrast = Color(0xFFFFFFFF)
val backgroundLightHighContrast = Color(0xFFF8F9FF)
val onBackgroundLightHighContrast = Color(0xFF191C20)
val surfaceLightHighContrast = Color(0xFFF8F9FF)
val onSurfaceLightHighContrast = Color(0xFF000000)
val surfaceVariantLightHighContrast = Color(0xFFDFE3EB)
val onSurfaceVariantLightHighContrast = Color(0xFF000000)
val outlineLightHighContrast = Color(0xFF282D33)
val outlineVariantLightHighContrast = Color(0xFF454950)
val scrimLightHighContrast = Color(0xFF000000)
val inverseSurfaceLightHighContrast = Color(0xFF2D3135)
val inverseOnSurfaceLightHighContrast = Color(0xFFFFFFFF)
val inversePrimaryLightHighContrast = Color(0xFF9ECAFC)
val surfaceDimLightHighContrast = Color(0xFFB6B9BE)
val surfaceBrightLightHighContrast = Color(0xFFF8F9FF)
val surfaceContainerLowestLightHighContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightHighContrast = Color(0xFFEFF0F7)
val surfaceContainerLightHighContrast = Color(0xFFE0E2E8)
val surfaceContainerHighLightHighContrast = Color(0xFFD2D4DA)
val surfaceContainerHighestLightHighContrast = Color(0xFFC4C6CC)

val primaryDark = Color(0xFF9ECAFC)
val onPrimaryDark = Color(0xFF003256)
val primaryContainerDark = Color(0xFF154974)
val onPrimaryContainerDark = Color(0xFFD0E4FF)
val secondaryDark = Color(0xFFBAC8DB)
val onSecondaryDark = Color(0xFF243140)
val secondaryContainerDark = Color(0xFF3B4857)
val onSecondaryContainerDark = Color(0xFFD6E4F7)
val tertiaryDark = Color(0xFFD5BEE5)
val onTertiaryDark = Color(0xFF3A2A48)
val tertiaryContainerDark = Color(0xFF514060)
val onTertiaryContainerDark = Color(0xFFF1DBFF)
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF101418)
val onBackgroundDark = Color(0xFFE0E2E8)
val surfaceDark = Color(0xFF101418)
val onSurfaceDark = Color(0xFFE0E2E8)
val surfaceVariantDark = Color(0xFF42474E)
val onSurfaceVariantDark = Color(0xFFC2C7CF)
val outlineDark = Color(0xFF8C9199)
val outlineVariantDark = Color(0xFF42474E)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFE0E2E8)
val inverseOnSurfaceDark = Color(0xFF2D3135)
val inversePrimaryDark = Color(0xFF33618D)
val surfaceDimDark = Color(0xFF101418)
val surfaceBrightDark = Color(0xFF36393E)
val surfaceContainerLowestDark = Color(0xFF0B0E12)
val surfaceContainerLowDark = Color(0xFF191C20)
val surfaceContainerDark = Color(0xFF1D2024)
val surfaceContainerHighDark = Color(0xFF272A2F)
val surfaceContainerHighestDark = Color(0xFF32353A)

val primaryDarkMediumContrast = Color(0xFFC5DFFF)
val onPrimaryDarkMediumContrast = Color(0xFF002745)
val primaryContainerDarkMediumContrast = Color(0xFF6894C3)
val onPrimaryContainerDarkMediumContrast = Color(0xFF000000)
val secondaryDarkMediumContrast = Color(0xFFD0DDF1)
val onSecondaryDarkMediumContrast = Color(0xFF192735)
val secondaryContainerDarkMediumContrast = Color(0xFF8492A4)
val onSecondaryContainerDarkMediumContrast = Color(0xFF000000)
val tertiaryDarkMediumContrast = Color(0xFFECD4FC)
val onTertiaryDarkMediumContrast = Color(0xFF2F1F3D)
val tertiaryContainerDarkMediumContrast = Color(0xFF9E89AD)
val onTertiaryContainerDarkMediumContrast = Color(0xFF000000)
val errorDarkMediumContrast = Color(0xFFFFD2CC)
val onErrorDarkMediumContrast = Color(0xFF540003)
val errorContainerDarkMediumContrast = Color(0xFFFF5449)
val onErrorContainerDarkMediumContrast = Color(0xFF000000)
val backgroundDarkMediumContrast = Color(0xFF101418)
val onBackgroundDarkMediumContrast = Color(0xFFE0E2E8)
val surfaceDarkMediumContrast = Color(0xFF101418)
val onSurfaceDarkMediumContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkMediumContrast = Color(0xFF42474E)
val onSurfaceVariantDarkMediumContrast = Color(0xFFD8DCE5)
val outlineDarkMediumContrast = Color(0xFFAEB2BA)
val outlineVariantDarkMediumContrast = Color(0xFF8C9198)
val scrimDarkMediumContrast = Color(0xFF000000)
val inverseSurfaceDarkMediumContrast = Color(0xFFE0E2E8)
val inverseOnSurfaceDarkMediumContrast = Color(0xFF272A2F)
val inversePrimaryDarkMediumContrast = Color(0xFF174B75)
val surfaceDimDarkMediumContrast = Color(0xFF101418)
val surfaceBrightDarkMediumContrast = Color(0xFF424549)
val surfaceContainerLowestDarkMediumContrast = Color(0xFF05080B)
val surfaceContainerLowDarkMediumContrast = Color(0xFF1B1E22)
val surfaceContainerDarkMediumContrast = Color(0xFF25282D)
val surfaceContainerHighDarkMediumContrast = Color(0xFF303337)
val surfaceContainerHighestDarkMediumContrast = Color(0xFF3B3E43)

val primaryDarkHighContrast = Color(0xFFE8F1FF)
val onPrimaryDarkHighContrast = Color(0xFF000000)
val primaryContainerDarkHighContrast = Color(0xFF9AC6F8)
val onPrimaryContainerDarkHighContrast = Color(0xFF000C1A)
val secondaryDarkHighContrast = Color(0xFFE8F1FF)
val onSecondaryDarkHighContrast = Color(0xFF000000)
val secondaryContainerDarkHighContrast = Color(0xFFB6C4D7)
val onSecondaryContainerDarkHighContrast = Color(0xFF010C19)
val tertiaryDarkHighContrast = Color(0xFFFAEBFF)
val onTertiaryDarkHighContrast = Color(0xFF000000)
val tertiaryContainerDarkHighContrast = Color(0xFFD1BAE1)
val onTertiaryContainerDarkHighContrast = Color(0xFF130421)
val errorDarkHighContrast = Color(0xFFFFECE9)
val onErrorDarkHighContrast = Color(0xFF000000)
val errorContainerDarkHighContrast = Color(0xFFFFAEA4)
val onErrorContainerDarkHighContrast = Color(0xFF220001)
val backgroundDarkHighContrast = Color(0xFF101418)
val onBackgroundDarkHighContrast = Color(0xFFE0E2E8)
val surfaceDarkHighContrast = Color(0xFF101418)
val onSurfaceDarkHighContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkHighContrast = Color(0xFF42474E)
val onSurfaceVariantDarkHighContrast = Color(0xFFFFFFFF)
val outlineDarkHighContrast = Color(0xFFECF0F9)
val outlineVariantDarkHighContrast = Color(0xFFBEC3CB)
val scrimDarkHighContrast = Color(0xFF000000)
val inverseSurfaceDarkHighContrast = Color(0xFFE0E2E8)
val inverseOnSurfaceDarkHighContrast = Color(0xFF000000)
val inversePrimaryDarkHighContrast = Color(0xFF174B75)
val surfaceDimDarkHighContrast = Color(0xFF101418)
val surfaceBrightDarkHighContrast = Color(0xFF4D5055)
val surfaceContainerLowestDarkHighContrast = Color(0xFF000000)
val surfaceContainerLowDarkHighContrast = Color(0xFF1D2024)
val surfaceContainerDarkHighContrast = Color(0xFF2D3135)
val surfaceContainerHighDarkHighContrast = Color(0xFF383C40)
val surfaceContainerHighestDarkHighContrast = Color(0xFF44474C)

object AppColors {
    val primaryBlue = Color(0xFF33618D)
    val borderColor = Color(0xFF42474E)
    val borderColorOne = Color(0xFFD6E4F7)

    val customBlack = Color(0xFF3A3A3A)
    val customWhite = Color(0xFFFFFFFF)

    val customEnable = Color(0xFF009325)
    val customYellow = Color(0xFFAE9703)

    val lightBlueBackground = Color(0xFFD8F0FF)

    val lightRed = Color(0xFFFF6E6E)
    val peach = Color(0xFFFF926E)
    val lightPurple = Color(0xFF706EFF)
}
